<template>
  <div class="contact-import-preview-step">
    <div class="box">
      <div class="level">
        <div class="level-left">
          <div>
            <h2 class="title is-5">Datos</h2>
            <p class="subtitle is-6">
              Revisión de las filas leídas desde el archivo.
            </p>
          </div>
        </div>

        <div class="level-right">
          <b-tag type="is-info" class="mr-2"> {{ rows.length }} filas </b-tag>

          <b-tag :type="hasErrors ? 'is-danger' : 'is-success'">
            {{ hasErrors ? "Con errores" : "Sin errores" }}
          </b-tag>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :data="rows"
          :striped="true"
          :hoverable="true"
          :mobile-cards="true"
          :paginated="rows.length > perPage"
          :per-page="perPage"
          :current-page.sync="currentPage"
          pagination-position="both"
          aria-next-label="Siguiente página"
          aria-previous-label="Página anterior"
          aria-page-label="Página"
          aria-current-label="Página actual"
        >
          <b-table-column field="row" label="Fila" width="70" v-slot="props">
            {{ props.row.row }}
          </b-table-column>

          <b-table-column field="delegation" label="Delegación" v-slot="props">
            {{ props.row.delegation }}
          </b-table-column>

          <b-table-column
            field="num_affiliate"
            label="N° afiliado"
            v-slot="props"
          >
            {{ props.row.num_affiliate }}
          </b-table-column>

          <b-table-column field="plan" label="Plan" v-slot="props">
            {{ props.row.plan }}
          </b-table-column>

          <b-table-column
            field="fullname"
            label="Nombre completo"
            v-slot="props"
          >
            {{ props.row.fullname }}
          </b-table-column>

          <b-table-column field="dni" label="DNI" v-slot="props">
            {{ props.row.dni }}
          </b-table-column>

          <b-table-column field="date_birth" label="Nacimiento" v-slot="props">
            {{ props.row.date_birth }}
          </b-table-column>

          <b-table-column field="cuil" label="CUIL" v-slot="props">
            {{ props.row.cuil }}
          </b-table-column>

          <b-table-column field="email" label="Email" v-slot="props">
            <span class="crm-truncate" :title="props.row.email">
              {{ props.row.email }}
            </span>
          </b-table-column>

          <b-table-column
            field="relationship"
            label="Parentesco"
            v-slot="props"
          >
            {{ props.row.relationship }}
          </b-table-column>

          <b-table-column field="errors" label="Errores" v-slot="props">
            <span
              v-if="!props.row.errors || !props.row.errors.length"
              class="has-text-success"
            >
              -
            </span>

            <div v-else>
              <b-tag
                v-for="(error, index) in props.row.errors"
                :key="index"
                type="is-danger"
                class="mr-1 mb-1"
              >
                {{ error }}
              </b-tag>
            </div>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered">No hay datos para mostrar.</div>
          </template>
        </b-table>
      </div>

      <div
        v-if="validation && validation.isValid"
        class="notification is-info is-light mt-4"
      >
        El archivo está listo para importar.
      </div>

      <div
        v-if="validation && !validation.isValid"
        class="notification is-danger is-light mt-4"
      >
        El archivo tiene errores. Corrige los datos antes de continuar.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactImportPreviewStep",

  props: {
    rows: {
      type: Array,
      default: () => [],
    },

    validation: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      perPage: 10,
      currentPage: 1,
    };
  },

  computed: {
    hasErrors() {
      return this.rows.some((row) => row.errors && row.errors.length);
    },
  },

  watch: {
    rows() {
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 1rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}

.table-wrapper ::v-deep table {
  min-width: 1100px;
}
</style>
